export const actions = {
	nuxtServerInit({ commit }, { req }) {
		const auth_token = this.$cookies.get('auth_token')
		if (auth_token) commit('setAuthToken', auth_token)
	},
}
